import React from "react";
import { NavLink } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import RouteIcon from "@mui/icons-material/Route";

const NAV_ITEMS = [
  {
    to: "/orders",
    label: "Orders",
    icon: LocalShippingOutlinedIcon,
  },
  {
    to: "/routes",
    label: "Routes",
    icon: RouteIcon,
  },
];

export const MOBILE_BOTTOM_NAV_HEIGHT = "calc(4.25rem + env(safe-area-inset-bottom, 0px))";

export function MobileBottomNav() {
  return (
    <Box
      component="nav"
      aria-label="Mobile navigation"
      sx={{
        position: "fixed",
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 20,
        display: "flex",
        alignItems: "stretch",
        justifyContent: "space-around",
        gap: 0.5,
        px: 1,
        pt: 0.75,
        pb: "max(0.5rem, env(safe-area-inset-bottom, 0px))",
        bgcolor: "#fff",
        borderTop: "1px solid #e5e9ef",
        boxShadow: "0 -4px 20px rgba(15, 23, 42, 0.06)",
      }}
    >
      {NAV_ITEMS.map(({ to, label, icon: Icon }) => (
        <NavLink key={to} to={to} style={{ textDecoration: "none", flex: 1 }}>
          {({ isActive }) => (
            <Box
              sx={{
                minHeight: 56,
                borderRadius: "12px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: 0.35,
                color: isActive ? "#5fa67a" : "#64748b",
                bgcolor: isActive ? "#eef7f1" : "transparent",
                transition: "all 0.2s ease",
              }}
            >
              <Icon sx={{ fontSize: 22 }} />
              <Typography
                sx={{
                  fontSize: "0.72rem",
                  fontWeight: 700,
                  lineHeight: 1,
                }}
              >
                {label}
              </Typography>
            </Box>
          )}
        </NavLink>
      ))}
    </Box>
  );
}
